import { create } from "zustand";
import { persist } from "zustand/middleware";

import type { LeadLinkColumnConfig } from "../model";

interface LinksPageConfigState {
  columns: LeadLinkColumnConfig[];
  editColumn: (id: string) => void;
  addColumns: (columns: LeadLinkColumnConfig[]) => void;
  removeColumns: (columns: LeadLinkColumnConfig[]) => void;
  resetColumns: () => void;
  removeDuplicates: () => void;
}

export const WORKER_HIDDEN_LINKS_PAGE_COLUMN_IDS = [
  "CR",
  "AD",
  "AP",
  "CPC",
  "CPL",
  "CPS",
  "EPC",
  "EPL",
  "EPS",
] as const;

const LINKS_PAGE_DEFAULT_COLUMNS: LeadLinkColumnConfig[] = [
  { id: "name", title: "Название", visible: true, locked: true },
  { id: "description", title: "Описание", visible: true, locked: true },
  { id: "leadsCount", title: "Лидов", visible: true, locked: true },
  { id: "costs", title: "Траты", visible: true, locked: true },
  { id: "totalProfit", title: "Заработок", visible: true, locked: true },
  { id: "depositsCount", title: "Кол-во Депов", visible: true, locked: false },
  { id: "createdAt", title: "Создана", visible: true, locked: false },
  { id: "type", title: "Тип", visible: true, locked: true },
  { id: "url", title: "Ссылка (действия)", visible: true, locked: false },
];

export const useLinksPageConfigStore = create(
  persist<LinksPageConfigState>(
    (set, get) => ({
      columns: LINKS_PAGE_DEFAULT_COLUMNS,

      editColumn: (id: string) => {
        const columns = get().columns.map((col) =>
          col.id === id && !col.locked
            ? { ...col, visible: !col.visible }
            : col,
        );
        set({ columns });
      },
      addColumns: (columns: LeadLinkColumnConfig[]) => {
        const currentColumns = get().columns;
        const newColumns = columns.filter(
          (newCol) => !currentColumns.some((col) => col.id === newCol.id),
        );
        if (newColumns.length > 0) {
          set({ columns: [...currentColumns, ...newColumns] });
        }
      },
      removeColumns: (columns: LeadLinkColumnConfig[]) => {
        const currentColumns = get().columns;
        const columnsToRemove = new Set(columns.map((col) => col.id));
        const newColumns = currentColumns.filter(
          (col) => !columnsToRemove.has(col.id),
        );
        set({ columns: newColumns });
      },
      resetColumns: () => {
        set({ columns: LINKS_PAGE_DEFAULT_COLUMNS });
      },
      removeDuplicates: () => {
        const currentColumns = get().columns;
        const uniqueColumns = currentColumns.filter(
          (column, index, self) =>
            index === self.findIndex((c) => c.id === column.id),
        );
        set({ columns: uniqueColumns });
      },
    }),
    {
      name: "links-page-config",
    },
  ),
);
